import { Repeat } from 'lucide-react';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dấu ↻ trên một task sinh từ mẫu việc định kỳ — APM-REC-c.
 *
 * Nói cho người làm biết việc này **sẽ quay lại**: làm xong không có nghĩa là
 * hết, và sửa nội dung ở đây chỉ sửa lần này — muốn đổi mọi lần sau thì sửa
 * mẫu ở cách nhìn "Định kỳ". Tooltip nói đúng điều đó.
 */
export function RecurringMark(): ReactNode {
  const { t } = useTranslation();
  return (
    <span
      role="img"
      aria-label={t('recurrence.mark')}
      title={t('recurrence.markHelp')}
      className="inline-flex shrink-0 text-primary"
    >
      <Repeat aria-hidden className="size-3" />
    </span>
  );
}
